


export const FAQ_ACCOUNT_MANAGEMENT = {
  title: "QUẢN LÝ ỨNG DỤNG VÀ TÀI KHOẢN",
  subItems: [
    {
      id: 'app-management',
      title: "Tải, xóa, cập nhật ứng dụng",
      contentItems: [
        {
          id: 'cau-1',
          title: "Khi gỡ bỏ ứng dụng trên điện thoại thì tiền trong tài khoản GooPay và thông tin giao dịch có bị mất hay không?",
          content: (
            <div>
              <p className="text-gray-700">Việc gỡ bỏ ứng dụng không ảnh hưởng đến tài khoản Ví GooPay và các thông tin giao dịch khác, vì toàn bộ dữ liệu đã được ghi nhận và lưu trữ trên hệ thống máy chủ tại trung tâm.</p>
              <p className="text-gray-700 mt-2">Ngay khi bạn cài đặt lại ứng dụng, các thông tin trong tài khoản sẽ được phục hồi như cũ.</p>
            </div>
          )
        },
        {
          id: 'cau-2',
          title: "Tôi có thể kiểm tra phiên bản ứng dụng GooPay ở đâu?",
          content: (
            <div>
              <p className="text-gray-700">Bước 1: Từ màn hình chính của ứng dụng, chọn "Ví của tôi"</p>
              <p className="text-gray-700">Bước 2: Nhấn vào "Cài đặt" ở góc phải trên cùng</p>
              <p className="text-gray-700">Bước 3: Nhấn vào "Thông tin ứng dụng"</p>
              <p className="text-gray-700 mt-2">Tại đây, bạn có thể đọc được phiên bản ứng dụng hiển thị ngay bên dưới logo GooPay.</p>
            </div>
          )
        },
        {
          id: 'cau-3',
          title: "Cách cập nhật phiên bản ứng dụng GooPay mới nhất",
          content: (
            <div>
              <p className="text-gray-700">Bạn hãy vào CH Play (dành cho Android) hoặc App Store (dành cho IOS) và nhập "GooPay" để tìm ứng dụng Ví GooPay, sau đó chọn "Cập nhật".</p>
              <p className="text-gray-700 mt-2">Chú ý: bạn có thể vào mục "Cài đặt" trên điện thoại của bạn và chọn chế độ tự động cập nhật ứng dụng khi có phiên bản mới.</p>
            </div>
          )
        }
      ]
    },
    {
      id: 'account-registration',
      title: "Đăng ký, đăng nhập và đổi tài khoản",
      contentItems: [
        {
          id: 'cau-4',
          title: "Tôi có thể đăng ký bao nhiêu tài khoản GooPay?",
          content: (
            <div>
              <p className="text-gray-700">Một khách hàng (tương ứng với 1 CCCD) có thể đăng kí tối đa 3 tài khoản GooPay để sử dụng.</p>
            </div>
          )
        },
        {
          id: 'cau-5',
          title: "Tôi có thể đăng nhập vào cùng một tài khoản GooPay trên nhiều thiết bị được không?",
          content: (
            <div>
              <p className="text-gray-700">Một tài khoản GooPay chỉ có thể đăng nhập trên một thiết bị tại một thời điểm. Khi bạn sử dụng thiết bị mới để đăng nhập vào tài khoản, ứng dụng GooPay trên thiết bị hiện tại sẽ tự động đăng xuất khỏi tài khoản.</p>
            </div>
          )
        },
        {
          id: 'cau-6',
          title: "Tôi có thể đổi số điện thoại đăng ký tài khoản GooPay của tôi được không?",
          content: (
            <div>
              <p className="text-gray-700">Hiện tại, Ví GooPay không hỗ trợ chuyển tài khoản GooPay từ số điện thoại này sang một số điện thoại khác. Nếu có nhu cầu thay đổi số điện thoại, bạn có thể tạo tài khoản GooPay mới với số điện thoại mới, và chuyển tiền từ tài khoản GooPay cũ sang tài khoản GooPay mới. Sau đó, bạn có thể hủy tài khoản GooPay cũ bằng cách liên hệ với bộ phận CSKH qua số 19006038 để được hỗ trợ hủy tài khoản.</p>
            </div>
          )
        },
        {
          id: 'cau-7',
          title: "Tôi có thể đăng nhập vào nhiều tài khoản GooPay trên cùng một thiết bị được không?",
          content: (
            <div>
              <p className="text-gray-700">Mỗi thiết bị chỉ có thể đăng nhập vào một tài khoản GooPay tại một thời điểm. Để đăng nhập vào tài khoản GooPay khác trên cùng thiết bị, bạn cần phải đăng xuất khỏi tài khoản hiện tại trên thiết bị đó rồi đăng nhập vào tài khoản mới.</p>
              <p className="text-gray-700 mt-2">Lưu ý: bạn chỉ có thể đăng nhập tối đa 3 tài khoản trên cùng một thiết bị di động trong 1 tháng. Theo quy định bảo mật của GooPay, nếu bạn đăng nhập quá 3 thiết bị, ứng dụng GooPay trên điện thoại của bạn sẽ tự động khóa.</p>
            </div>
          )
        },
        {
          id: 'cau-8',
          title: "Cách đăng nhập vào tài khoản GooPay khác",
          content: (
            <div>
              <p className="text-gray-700">Bước 1: Tại màn hình đăng nhập, chọn "Đổi SĐT".</p>
              <p className="text-gray-700">Bước 2: Nhập số điện thoại rồi chọn "Tiếp tục"</p>
              <p className="text-gray-700">Bước 3: Nhập mã OTP (mã xác thực được gửi qua tin nhắn đến số điện thoại bạn nhập)</p>
              <p className="text-gray-700">Bước 4: Nhập mật khẩu đăng nhập</p>
            </div>
          )
        }
      ]
    },
    {
      id: 'password-verification',
      title: "Mật khẩu, xác thực tài khoản & email",
      contentItems: [
        {
          id: 'cau-9',
          title: "Mã OTP là gì? Mã OTP được gửi cho tôi trong những trường hợp nào?",
          content: (
            <div>
              <p className="text-gray-700">Mã xác thực OTP - One Time Password là loại mật khẩu sử dụng một lần và được coi là lớp bảo vệ thứ hai cho các tài khoản ngân hàng điện tử, thanh toán trực tuyến hay e-mail, mạng xã hội.</p>
              <p className="text-gray-700 mt-2">Mã OTP được gửi qua tin nhắn SMS đến đúng số điện thoại đăng ký tài khoản GooPay mà bạn đang sử dụng. GooPay sẽ gửi mã OTP cho bạn trong những trường hợp:</p>
              <ol className="mt-2 space-y-1">
                <li>1. Đăng kí tài khoản mới</li>
                <li>2. Đổi số điện thoại/ đăng nhập tài khoản GooPay khác</li>
              </ol>
              <p className="text-gray-700 mt-2">Trường hợp khi bạn liên kết tài khoản ngân hàng với tài khoản GooPay, bạn sẽ nhận được mã OTP gửi đến từ ngân hàng của bạn.</p>
            </div>
          )
        },
        {
          id: 'cau-10',
          title: "Tôi không nhận được mã OTP",
          content: (
            <div>
              <p className="text-gray-700">Trong trường hợp bạn không nhận được mã OTP trong vòng 30 giây, bạn có thể nhấn vào "Gửi lại" để hệ thống gửi lại một mã OTP khác cho bạn.</p>
              <p className="text-gray-700 mt-2">Trường hợp vẫn không nhận được mã OTP, có thể do lỗi kết nối mạng. Vui lòng thử lại sau một lúc, hoặc liên hệ với bộ phận CSKH qua số 19006038 để được hỗ trợ.</p>
            </div>
          )
        },
        {
          id: 'cau-11',
          title: "Quy định về việc đổi mật khẩu",
          content: (
            <div>
              <p className="text-gray-700">Mỗi 6 tháng GooPay sẽ yêu cầu bạn đổi mật khẩu để đảm bảo sự bảo mật tài khoản. Mật khẩu mới không được trùng với mật khẩu hiện tại.</p>
            </div>
          )
        },
        {
          id: 'cau-12',
          title: "Cách đổi mật khẩu",
          content: (
            <div>
              <p className="text-gray-700">Bước 1: Từ màn hình chính của ứng dụng chọn 'Ví của tôi', chọn 'Cài đặt' ở góc phải trên cùng</p>
              <p className="text-gray-700">Bước 2: Chọn 'Thiết lập bảo mật tài khoản' rồi chọn 'Đổi mật khẩu'</p>
              <p className="text-gray-700">Bước 3: Nhập mật khẩu hiện tại rồi mật khẩu mới 2 lần.</p>
              <p className="text-gray-700">Bước 4: Chọn 'Xác nhận'.</p>
              <p className="text-gray-700 mt-2">Lưu ý: Mật khẩu mới không được trùng với mật khẩu hiện tại. GooPay khuyên bạn Không nên chọn mật khẩu đơn giản theo ngày sinh và số điện thoại của mình, không chọn mật khẩu "123456" hoặc gồm 6 chữ số giống nhau.</p>
            </div>
          )
        },
        {
          id: 'cau-13',
          title: "Cách cập nhật thông tin cá nhân",
          content: (
            <div>
              <p className="text-gray-700">Bước 1: Từ màn hình chính của ứng dụng chọn 'Ví của tôi', chọn 'Cài đặt' ở góc phải trên cùng</p>
              <p className="text-gray-700">Bước 2: Chọn 'Thông tin cá nhân'</p>
              <p className="text-gray-700">Bước 3: Chọn thông tin bạn muốn cập nhật và nhập thông tin mới</p>
              <p className="text-gray-700">Bước 4: Chọn 'Lưu' để hoàn tất</p>
            </div>
          )
        }
      ]
    },
    {
      id: 'account-lock',
      title: "Khóa, hủy, mở lại tài khoản",
      contentItems: [
        {
          id: 'cau-14',
          title: "Tài khoản GooPay bị khóa khi nào?",
          content: (
            <div>
              <p className="text-gray-700">Tài khoản GooPay có thể bị khóa trong các trường hợp sau:</p>
              <ol className="mt-2 space-y-1">
                <li>1. Nhập sai mật khẩu quá 5 lần liên tiếp</li>
                <li>2. Đăng nhập trên quá 3 thiết bị khác nhau trong 1 tháng</li>
                <li>3. Có hoạt động bất thường hoặc vi phạm quy định sử dụng</li>
                <li>4. Yêu cầu từ chủ tài khoản</li>
              </ol>
            </div>
          )
        },
        {
          id: 'cau-15',
          title: "Cách mở khóa tài khoản GooPay",
          content: (
            <div>
              <p className="text-gray-700">Để mở khóa tài khoản GooPay, bạn cần:</p>
              <p className="text-gray-700">Bước 1: Liên hệ với bộ phận CSKH qua số 19006038</p>
              <p className="text-gray-700">Bước 2: Cung cấp thông tin xác thực tài khoản</p>
              <p className="text-gray-700">Bước 3: Tuân thủ quy trình xác minh của GooPay</p>
              <p className="text-gray-700 mt-2">Sau khi xác minh thành công, tài khoản sẽ được mở khóa trong vòng 24 giờ.</p>
            </div>
          )
        },
        {
          id: 'cau-16',
          title: "Cách hủy tài khoản GooPay",
          content: (
            <div>
              <p className="text-gray-700">Để hủy tài khoản GooPay, bạn cần:</p>
              <p className="text-gray-700">Bước 1: Rút toàn bộ số tiền trong tài khoản</p>
              <p className="text-gray-700">Bước 2: Liên hệ với bộ phận CSKH qua số 19006038</p>
              <p className="text-gray-700">Bước 3: Cung cấp thông tin xác thực và lý do hủy tài khoản</p>
              <p className="text-gray-700 mt-2">Lưu ý: Việc hủy tài khoản là không thể đảo ngược. Tất cả dữ liệu và lịch sử giao dịch sẽ bị xóa vĩnh viễn.</p>
            </div>
          )
        }
      ]
    }
  ]
}; 